import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type PaymentContext as SchemaPaymentContext } from '../schemas/PaymentContext';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetPaymentContextContentType = '' as const;
export type GetPaymentContextRequest = undefined;
export type GetPaymentContextResponses = LinkCommonErrorResponses & {
    /**
     * @description Payment context
     */
    '200': {
        'application/json': SchemaPaymentContext;
    };
};
export type GetPaymentContextResponseSuccess = GetPaymentContextResponses['200']['application/json'];
export type GetPaymentContextSearchParams = {
    on_error_redirect?: string;
    on_success_redirect?: string;
    on_abort_redirect?: string;
    signature: string;
    initial_payment_options?: string;
    logged_in: boolean;
};
export type GetPaymentContextPathParameters = {
    store_slug: string;
    order_id: string;
};
export const GetPaymentContextUrl = '/{store_slug}/orders/{order_id}/payment_context' as const;
export const GetPaymentContextMethod = 'GET' as const;
export const getGetPaymentContextUrl = (params: GetPaymentContextPathParameters) =>
    GetPaymentContextUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetPaymentContextPathParameters) =>
        String(params[param])
    );
